import axios from 'axios'
import { getUrlParams } from '@/utils/url'
import { supportFormatWebp } from '@/utils/general'
import App from '../main.js'

const { lang, campground } = getUrlParams()

let baseURL = process.env.VUE_APP_API_ENDPOINT
let baseDomain = 'camping.info'
const baseDomainParts = baseURL.split('.')
const len = baseDomainParts.length
if (len > 2) {
  baseDomain = `${baseDomainParts[len - 2]}.${baseDomainParts[len - 1]}`
  if (baseDomainParts.slice(1).join('.') === 'test.acsicamping.info') {
    baseDomain = 'test.acsicamping.info'
  }
}
const backend = new URLSearchParams(window.location.search).get('backend')
if (backend && backend.match(/^[a-z0-9_-]+$/i)) {
  baseURL = `https://${backend}.${baseDomain}`
}

baseURL = `${baseURL}/{lang}/api`

let TOKEN = null

// exposing HTTP is needed for mocking in tests
export const HTTP = axios.create({
  baseURL: baseURL.replace('{lang}', lang),
})

/* istanbul ignore next */
HTTP.interceptors.request.use(config => {
  App.$Progress.start() // for every request start the progress
  return config
})

/* istanbul ignore next */
HTTP.interceptors.response.use(response => {
  App.$Progress.finish() // finish when a response is received
  return response
})

// exposed api
export const Api = {
  getCampgroundData: language => getCampgroundData(language),
  getData: (url, params) => getData(url, params),
  postData: (url, params) => postData(url, params),
  setToken: token => {
    TOKEN = token
  },
}

const getCampgroundData = async (language = null, params = {}) => {
  if (supportFormatWebp()) {
    params.image_format = 'webp'
  }
  HTTP.defaults.baseURL = baseURL.replace('{lang}', language || lang)
  const result = await HTTP.get(
    `/checkout-data/${campground}/`,
    getConfigWithToken({ params })
  ).catch(error => onError(error))
  return result.data
}

const getData = async (url, params = {}) => {
  if (supportFormatWebp()) {
    params.image_format = 'webp'
  }

  const result = await HTTP.get(url, getConfigWithToken(params)).catch(error =>
    onError(error)
  )
  return result.data
}

const postData = async (url, params = {}) => {
  if (TOKEN) {
    let tokenParam = `token=${encodeURIComponent(TOKEN)}`
    if (url.indexOf('?') !== -1) {
      url += `&${tokenParam}`
    } else {
      url += `?${tokenParam}`
    }
  }

  const result = await HTTP.post(url, params).catch(error => onError(error))
  return result.data
}

// on error function
const onError = error => {
  console.warn(error)
  throw error
}

const getConfigWithToken = (config = null) => {
  if (!TOKEN) {
    return config
  }

  if (!config) {
    config = {}
  }

  if (!config.params) {
    config.params = {}
  }

  config.params.token = TOKEN
  return config
}
